import "./App.css";
import "antd/dist/antd.min.css";
import MainPage from "./Components/MainPage";

function App() {
	return (
		<div className="app">
			<MainPage />
		</div>
	);
}

export default App;
